import { Typography, TypographyProps } from '@mui/material';
import { color } from '@/colors';

export type { TypographyProps };

type AppTypographyProps = TypographyProps & {
  text?: string;
};

export const TextStdRg = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-std-rg" color={color.White64_T} {...props}>
    {text || children}
  </Typography>
);

export const TextStdMd = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-std-md" {...props}>
    {text || children}
  </Typography>
);

export const TextLgRg = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-lg-rg" {...props}>
    {text || children}
  </Typography>
);

export const TextLgMd = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-lg-md" {...props}>
    {text || children}
  </Typography>
);

export const TextLgSb = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-lg-sb" {...props}>
    {text || children}
  </Typography>
);

export const TextSmRg = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-sm-rg" {...props}>
    {text || children}
  </Typography>
);

export const TextSmMd = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="body-sm-md" {...props}>
    {text || children}
  </Typography>
);

export const LabelSmRg = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="label-sm-rg" {...props}>
    {text || children}
  </Typography>
);

export const H1 = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="h1" {...props}>
    {text || children}
  </Typography>
);

export const H2 = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="h2" {...props}>
    {text || children}
  </Typography>
);

export const H3 = ({ text, children, ...props }: AppTypographyProps) => (
  <Typography variant="h3" {...props}>
    {text || children}
  </Typography>
);

/**
 * Generic Typography pass-through for variants that don't have a dedicated preset yet.
 * Prefer the dedicated presets above (TextStdRg, TextLgRg, etc.) when possible.
 */
export { Typography };
